module.exports = __webpack_public_path__ + "img/12.1abaaa79.png";